import moment from 'moment';
import {graphql} from 'react-apollo';

import {
  RECALL_TIMESHEET_SUBMISSION_MUTATION,
  TIMESHEET_DETAIL_QUERY
} from '../../queries';
import {buildTsInput} from '../../../shared/utils/queries';

export default graphql(RECALL_TIMESHEET_SUBMISSION_MUTATION, {
  props: ({
    ownProps: {
      timesheet,
      setLoading,
      setError,
      setSuccess,
      clearLoading,
      client,
      date,
      timesheetUser
    },
    mutate
  }) => ({
    recallTimesheetSubmission(selectedDates) {
      const dates = timesheet.totals
        .filter(
          x =>
            selectedDates.includes(x.Date.format('YYYY-MM-DD')) &&
            x.Date <= moment() &&
            !(x.PostedToGL || x.Approved) &&
            x.Submitted
        )
        .map(x => x.Date.format('YYYY-MM-DD'));

      if (!dates.length) {
        return setError('There are no days which can be recalled.');
      }

      setLoading();

      const detailVars = {date, timesheetUser};

      mutate({
        variables: {
          ...buildTsInput(timesheet),
          dates
        },
        update(store, {data}) {
          const payload = data && data.recallTimesheetSubmission;
          const nextTs = payload && payload.ts;
          if (!nextTs) return;
          try {
            store.readQuery({query: TIMESHEET_DETAIL_QUERY, variables: detailVars});
            store.writeQuery({
              query: TIMESHEET_DETAIL_QUERY,
              variables: detailVars,
              data: {timesheet: nextTs}
            });
          } catch (e) {
            if (client) {
              client
                .query({
                  query: TIMESHEET_DETAIL_QUERY,
                  variables: detailVars,
                  fetchPolicy: 'network-only'
                })
                .catch(() => {});
            }
          }
        }
      })
        .then(
          ({data: {recallTimesheetSubmission: {message}}}) => {
            setSuccess(message.toString());
          },
          e => setError(e)
        )
        .then(clearLoading);
    }
  })
});
